import { render, staticRenderFns } from "./NavbarIcon.vue?vue&type=template&id=4442e856&scoped=true"
import script from "./NavbarIcon.vue?vue&type=script&lang=ts"
export * from "./NavbarIcon.vue?vue&type=script&lang=ts"
import style0 from "./NavbarIcon.vue?vue&type=style&index=0&id=4442e856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4442e856",
  null
  
)

export default component.exports